// tslint:disable
import { get } from 'lodash';
import * as React from 'react';
import { CheckboxField } from '../../components/fields/checkbox.field';
import { DatepickerField } from '../../components/fields/datepicker.field';
import { InputField } from '../../components/fields/input.field';
import { ConsoleLib } from '../../components/libs/console.lib';
import { ListResourceLoader } from '../../components/libs/list-resource-loader';
import { ListLib } from '../../components/libs/list.lib';
import { ListConsole } from '../../components/structurals/list-console';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { Pagination } from '../../components/structurals/pagination';
import { IriPresenter } from '../../components/structurals/presenters/iri-presenter';
import { ListActions, ListResponsePresenterTable } from '../../components/structurals/presenters/list-response-presenter-table';
import * as moment from 'moment';

export class AtasMemberList extends React.Component<any, any> {

    async handleItemDelete(item: any, list: ListLib, listActions: ListActions, event: any) {
        event.preventDefault();
        event.stopPropagation();

        list.isLoading$.next(true);
        await listActions.delete(item['@id']);
        list.refetch()
    }

    render() {
        return (
            <ListResourceLoader entity="company" forceQuery={{limit: 30, 'order[id]': 'desc'}} render={(list: ListLib) => <div>
                <div id="page-title">
                    <h2>
                        Members
                        <div className="pull-right">
                            <a href="/member/create" className='btn btn-sm btn-primary'>Create new member</a>
                        </div>
                    </h2>
                    <p>Lorem</p>
                </div>

                <ListConsole
                    className="col-xs-12 col-lg-3 pull-right"
                    config={list.console}
                    render={(console: ConsoleLib) => <div>

                        <CheckboxField field={console.setQuery('companySiteSpec.featured', {title: 'Featured'})}/>
                        <CheckboxField field={console.setQuery('companySiteSpec.supplierExtra', {title: 'Supplier Extra'})}/>
                        <InputField field={console.setQuery('_keyword', {title: 'Search', placeholder: 'some keyword'})}/>
                        <DatepickerField field={console.setQuery('createdAt', {title: 'Created at'})}/>

                    </div>}
                />

                <div className="col-xs-12 col-lg-9 pull-left relative">
                    <LoaderComponent isLoading$={list.isLoading$}/>

                    <ListResponsePresenterTable
                        items={list.member}
                        head={() => {
                            return (
                                <tr>
                                    <th>#</th>
                                    <th>Title</th>
                                    <th>Membership type</th>
                                    <th>Last Payment Date</th>
                                    <th></th>
                                </tr>
                            );
                        }}
                        row={(item: any, index: number, actions: ListActions) => {
                            return (
                                <tr key={index}>
                                    <td>{get(item, 'id', '-')}</td>
                                    <td>{get(item, 'name', '-')}</td>
                                    <td>
                                        <IriPresenter iri={'/company-site-spec?company=' + get(item, 'id')} render={(siteSpec: any) =>
                                            <IriPresenter iri={get(siteSpec, 'hydra:member[0].type.@id')} render={(membershipType: any) =>
                                                get(membershipType, 'title')
                                            }/>
                                         }/>
                                    </td>
                                    <td>
                                        <IriPresenter iri={'/company-site-spec?company=' + get(item, 'id')} render={(sp: any) =>
                                            moment(get(sp, 'hydra:member[0].lastPaymentDate', '-')).format('DD/MM/Y HH:mm')
                                        }/>
                                    </td>
                                    <td className="text-center">
                                        <button className="btn btn-xs btn-primary" onClick={() => actions.open(`/member/${item['id']}`)}>Edit member</button>
                                    </td>
                                </tr>
                            );
                        }}/>

                    <Pagination config={list.pagination}/>

                </div>
            </div>}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/lists/atas.member.list.tsx